var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3258 26.4048V23.9255C21.3258 22.6104 20.8034 21.3491 19.8734 20.4192C18.9435 19.4892 17.6822 18.9668 16.3671 18.9668H6.44977C5.13464 18.9668 3.87338 19.4892 2.94345 20.4192C2.01352 21.3491 1.49109 22.6104 1.49109 23.9255V26.4048",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4084 14.0082C14.147 14.0082 16.3671 11.7881 16.3671 9.0495C16.3671 6.3109 14.147 4.09082 11.4084 4.09082C8.66984 4.09082 6.44977 6.3109 6.44977 9.0495C6.44977 11.7881 8.66984 14.0082 11.4084 14.0082Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7639 26.4048V23.9255C28.763 22.8268 28.3974 21.7595 27.7242 20.8911C27.0511 20.0228 26.1087 19.4026 25.0449 19.1279",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0861 4.25195C21.1528 4.52505 22.0982 5.14538 22.7733 6.01515C23.4484 6.88491 23.8149 7.95463 23.8149 9.05567C23.8149 10.1567 23.4484 11.2264 22.7733 12.0962C22.0982 12.966 21.1528 13.5863 20.0861 13.8594",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsLogo);
export default __webpack_public_path__ + "static/media/clients-logo.c9a2e343883ef678291822972ecd574a.svg";
export { ForwardRef as ReactComponent };